import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
// @ts-ignore
import { useDisplayTheme } from 'hooks/useUiState'
import SpinningQ from 'components/share/SpinningQ'

interface ConfirmDeleteDialogProps {
  open: boolean
  onClose?: () => void
  onOk?: () => void
  isDeleting?: boolean
}

const ConfirmDeleteDialog = ({ open, onClose, onOk, isDeleting }: ConfirmDeleteDialogProps) => {
  const mode = useDisplayTheme()
  const { t } = useTranslation()

  return (
    <Dialog mode={mode} open={open} width="600px" onClose={onClose}>
      <Dialog.DialogTitle>{t('confirmation')}</Dialog.DialogTitle>
      <Dialog.DialogContent>{t('confirmDeleteAnnotation')}</Dialog.DialogContent>
      <Dialog.DialogActions
        okButtonProps={{
          children: isDeleting ? `${t('deletingThreeDot')}` : t('ok'),
          onClick: onOk,
          startIcon: isDeleting ? <SpinningQ /> : undefined,
          disabled: isDeleting
        }}
        closeButtonProps={{
          disabled: isDeleting
        }}
      />
    </Dialog>
  )
}

export default ConfirmDeleteDialog
